const { REACT_APP_S3_BUCKET_IMAGES_URL } = process.env;

export default function getSystemNameImage(systemName) {
  return `${REACT_APP_S3_BUCKET_IMAGES_URL}/logos/platforms/${systemName}/main.png`;
}
